"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitialPointerState = void 0;
const getInitialPointerState = () => ({
    dragging: false,
    current: { position: { x: -1, y: -1 }, time: 0 },
    pinned: null,
    down: null,
    up: null,
    lastDrag: null,
    lastClick: null,
});
exports.getInitialPointerState = getInitialPointerState;
//# sourceMappingURL=get_initial_pointer_state.js.map